import NPLAlert from './NPLAlert';
export default NPLAlert;
